export enum translationGroups {
  accountPage = 'page-account',
  achievements = 'achievements',
  addFriend = 'add-friend',
  addHomescreenInfo = 'add-homescreen-info',
  altText = 'alt-text',
  api = 'api',
  assist = 'assist',
  brainpoints = 'brainpoints',
  breadcrumbs = 'breadcrumbs',
  calendarPage = 'page-calendar',
  campaignPage = 'page-campaign',
  clueBar = 'clue-bar',
  common = 'common',
  dailyDosePage = 'daily-dose-page',
  dictionary = 'dictionary',
  difficulty = 'difficulty',
  drawer = 'drawer',
  endscreenPage = 'page-endscreen',
  error = 'error',
  expression = 'expression',
  footer = 'footer',
  form = 'form',
  friendStatus = 'friend-status',
  fullscreen = 'fullscreen',
  gameroomMessages = 'gameroom-messages',
  gridToast = 'grid-toast',
  homePage = 'page-home',
  infoPage = 'page-info',
  invite = 'invite',
  invoice = 'invoice',
  startGame = 'start-game',
  landingPage = 'page-landing',
  loginPage = 'page-login',
  months = 'months',
  mistakes = 'mistakes',
  navigation = 'navigation',
  notificationBar = 'notification-bar',
  onboarding = 'onboarding',
  pageTitle = 'page-title',
  paymentCompletePage = 'payment-complete-page',
  paymentInputPage = 'payment-input-page',
  puzzle = 'puzzle',
  puzzlePlayer = 'puzzle-player',
  puzzlePack = 'puzzle-pack',
  puzzleInstructions = 'puzzle-instructions',
  puzzlePage = 'page-puzzles',
  puzzlePackTypesPage = 'page-puzzle-pack-types',
  puzzlePackTypePage = 'page-puzzle-pack-type',
  puzzleTags = 'puzzle-tags',
  qrGame = 'qr-game',
  rotateScreen = 'rotate-screen',
  sharePuzzle = 'share-puzzle',
  shareResult = 'share-result',
  startLightTrial = 'start-light-trial',
  statsPage = 'page-stats',
  subscriptions = 'subscriptions',
  usp = 'usp',
  weekDays = 'week-days',
  wordgroups = 'wordgroups',
}

export default translationGroups
